import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { UserProfileService } from '../../../shared/services/user-profile.service';
import { IUser } from '../../../shared/models/users/user.model';

@Component({
  selector: 'app-home',
  standalone: true,
  imports: [CommonModule, RouterModule],
  templateUrl: './home.component.html',
  styleUrl: './home.component.scss'
})
export class HomeComponent {

    currentUser$: IUser | null = null;
    constructor(private userProfileService: UserProfileService) {

        this.userProfileService.currentUser$.subscribe((user) => {
            this.currentUser$ = user;
        });
    }


  documents = [
    { title: 'User guide', description: 'How to use the platform', icon: 'pi-book', link: '/documentation', color: 'blue' },
    { title: 'Request process', description: 'Submitting and tracking requests', icon: 'pi-send', link: '/modules/requests', color: 'cyan' },
    { title: 'Contract workflow', description: 'Creating and signing contracts', icon: 'pi-file-edit', link: '/modules/contracts', color: 'purple' },
    { title: 'Client management', description: 'Managing clients and companies', icon: 'pi-users', link: '/modules/clients', color: 'orange' }
  ];

  flowSteps = [
    { label: 'Create request', path: '/modules/requests', icon: 'pi-plus-circle' },
    { label: 'Manage contracts', path: '/modules/contracts', icon: 'pi-file' },
    { label: 'Clients & companies', path: '/modules/clients', icon: 'pi-briefcase' }
  ];

}
